(function () {
  'use strict';

  // Default configuration - UPDATED
  const DEFAULT_CONFIG = {
    apiKey: '',
    chatbotId: '',
    // Bot credentials: provided directly by the site
    botUuid: '',
    botSecret: '',
    position: 'bottom-right',
    theme: 'dark',
    themeStyle: 'solid', // 'solid' or 'glass'
    primaryColor: '#3b82f6',
    welcomeMessage: 'Hello! How can I help you today?',
    placeholder: 'Type your message...',
    showWelcomeMessage: false,
    autoOpen: false,
    zIndex: 9999,
    // NEW FIELDS
    chatbotAvatar: '🤖',
    customAvatar: '',
    botName: 'Talkida AI',
    greetingMsg: 'Hello! How can I help you today?',
    byeMsg: 'Bye, have a great day!',
    notFoundInfo: 'I\'m sorry, I don\'t have that information at the moment.',
    customSystPrompt: '',
    maxTokens: 1024,
    temperature: 0.0,
    botAim: '',
    companyName: 'Talkida.co.in',
    llmProvider: 'google',
    modelName: 'gemini-2.5-flash-lite',
    // API/WS endpoints
    apiBaseUrl: 'https://api.talkida.co.in',
    wsPath: '/api/ws/chat'
  };

  // Widget class
  class TalkidaWidget {
    constructor(config = {}) {
      this.config = { ...DEFAULT_CONFIG, ...config };
      this.isOpen = false;
      this.isMinimized = false;
      this.messages = [];
      this.conversationId = null;
      this.widgetElement = null;
      this.chatButton = null;
      this.chatWindow = null;

      // WebSocket state
      this.websocket = null;
      this.isConnecting = false;
      this.isWsReady = false;
      this.pendingMessages = [];

      this.init();
    }

    // Theme color helpers
    getThemeColors() {
      const theme = this.config.theme || 'dark';
      const isLight = theme === 'light';
      const isBlack = theme === 'black';
      const isGlass = this.config.themeStyle === 'glass';

      if (isLight) {
        return {
          // Solid backgrounds
          background: '#ffffff',
          backgroundSecondary: '#f9fafb',
          backgroundTertiary: '#f3f4f6',
          border: '#e5e7eb',
          borderSecondary: '#d1d5db',
          text: '#1f2937',
          textSecondary: 'rgba(31,41,55,0.7)',
          inputBackground: '#ffffff',
          inputBorder: '#d1d5db',
          messageBackground: '#f3f4f6',

          // Glass-specific colors
          glassBackground: 'rgba(255, 255, 255, 0.75)',
          glassSecondary: 'rgba(249, 250, 251, 0.6)',
          glassTertiary: 'rgba(243, 244, 246, 0.5)',
          glassBorder: 'rgba(229, 231, 235, 0.3)',
          glassMessageBg: 'rgba(243, 244, 246, 0.7)',
          glassInputBg: 'rgba(255, 255, 255, 0.4)',
          glassInputBorder: 'rgba(209, 213, 219, 0.4)'
        };
      } else if (isBlack) {
        return {
          // Solid backgrounds
          background: '#000000',
          backgroundSecondary: '#0a0a0a',
          backgroundTertiary: '#1a1a1a',
          border: '#1f1f1f',
          borderSecondary: '#2a2a2a',
          text: '#ffffff',
          textSecondary: 'rgba(255,255,255,0.7)',
          inputBackground: '#1a1a1a',
          inputBorder: '#2a2a2a',
          messageBackground: '#2a2a2a',

          // Glass-specific colors
          glassBackground: 'rgba(0, 0, 0, 0.75)',
          glassSecondary: 'rgba(10, 10, 10, 0.6)',
          glassTertiary: 'rgba(26, 26, 26, 0.5)',
          glassBorder: 'rgba(255, 255, 255, 0.1)',
          glassMessageBg: 'rgba(42, 42, 42, 0.7)',
          glassInputBg: 'rgba(26, 26, 26, 0.5)',
          glassInputBorder: 'rgba(42, 42, 42, 0.4)'
        };
      } else { // dark
        return {
          // Solid backgrounds
          background: '#1f2937',
          backgroundSecondary: '#111827',
          backgroundTertiary: '#374151',
          border: '#374151',
          borderSecondary: '#4b5563',
          text: '#ffffff',
          textSecondary: 'rgba(255,255,255,0.7)',
          inputBackground: '#374151',
          inputBorder: '#4b5563',
          messageBackground: '#374151',

          // Glass-specific colors
          glassBackground: 'rgba(31, 41, 55, 0.75)',
          glassSecondary: 'rgba(17, 24, 39, 0.6)',
          glassTertiary: 'rgba(55, 65, 81, 0.5)',
          glassBorder: 'rgba(255, 255, 255, 0.15)',
          glassMessageBg: 'rgba(55, 65, 81, 0.7)',
          glassInputBg: 'rgba(55, 65, 81, 0.4)',
          glassInputBorder: 'rgba(75, 85, 99, 0.4)'
        };
      }
    }

    getGlassStyles() {
      const theme = this.config.theme || 'dark';
      const isLight = theme === 'light';
      const isBlack = theme === 'black';

      // Base glass effect properties
      const baseGlass = {
        backdropFilter: 'blur(20px) saturate(180%)',
        webkitBackdropFilter: 'blur(20px) saturate(180%)'
      };

      if (isLight) {
        return {
          ...baseGlass,
          background: 'rgba(255, 255, 255, 0.75)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15), inset 0 1px 0 0 rgba(255, 255, 255, 0.5)'
        };
      } else if (isBlack) {
        return {
          ...baseGlass,
          background: 'rgba(0, 0, 0, 0.75)',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.6), inset 0 1px 0 0 rgba(255, 255, 255, 0.05)'
        };
      } else { // dark
        return {
          ...baseGlass,
          background: 'rgba(31, 41, 55, 0.75)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.4), inset 0 1px 0 0 rgba(255, 255, 255, 0.1)'
        };
      }
    }

    getBackground(type) {
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';

      if (!isGlass) {
        return colors[type] || colors.background;
      }

      // Map solid background types to glass equivalents
      const glassMapping = {
        background: 'glassBackground',
        backgroundSecondary: 'glassSecondary',
        backgroundTertiary: 'glassTertiary',
        inputBackground: 'glassInputBg',
        messageBackground: 'glassMessageBg'
      };

      return colors[glassMapping[type]] || colors.glassBackground;
    }

    getBorder(type = 'border') {
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';

      if (isGlass) {
        return colors.glassBorder;
      }

      return colors[type] || colors.border;
    }

    getBackdropFilter() {
      const isGlass = this.config.themeStyle === 'glass';
      return isGlass ? 'blur(20px) saturate(180%)' : 'none';
    }

    // Format message text: bold asterisks and auto-link URLs
    formatMessage(text, primaryColor = '#3b82f6') {
      if (!text) return '';

      // First, escape HTML to prevent XSS
      const escapeHtml = (str) => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      };

      let formatted = escapeHtml(text);

      // Replace all text between asterisks (any number of *) with bold
      // Pattern: *text* or **text** or ***text*** etc.
      // This handles: *text*, **text**, ***text***, etc.
      formatted = formatted.replace(/\*+([^*]+)\*+/g, '<strong>$1</strong>');

      // Detect and convert URLs to clickable links
      // Pattern matches: http://, https://, www., or common TLDs
      const urlPattern = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+|[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+[^\s<>"']*)/g;
      formatted = formatted.replace(urlPattern, (url) => {
        // Skip if already inside an HTML tag
        if (url.includes('<') || url.includes('>')) return url;

        // Ensure URL has protocol
        let href = url.trim();
        if (!href.startsWith('http://') && !href.startsWith('https://')) {
          href = 'https://' + href;
        }
        return `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer" style="color: ${escapeHtml(primaryColor)}; text-decoration: underline; word-break: break-all;">${escapeHtml(url)}</a>`;
      });

      return formatted;
    }

    // Check if a color is light (bright/white shade)
    isLightColor(color) {
      if (!color) return false;

      // Remove # if present
      const hex = color.replace('#', '');

      // Handle rgb/rgba colors
      if (color.startsWith('rgb')) {
        const matches = color.match(/\d+/g);
        if (matches && matches.length >= 3) {
          const r = parseInt(matches[0]);
          const g = parseInt(matches[1]);
          const b = parseInt(matches[2]);
          // Calculate relative luminance
          const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
          return luminance > 0.6; // Consider light if luminance > 60%
        }
        return false;
      }

      // Handle hex colors
      if (hex.length === 3) {
        const r = parseInt(hex[0] + hex[0], 16);
        const g = parseInt(hex[1] + hex[1], 16);
        const b = parseInt(hex[2] + hex[2], 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.6;
      }

      if (hex.length === 6) {
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.6;
      }

      return false;
    }

    // Get contrasting color for "Powered by" link based on theme and primary color
    getContrastingLinkColor() {
      const theme = this.config.theme || 'dark';
      const primaryColor = this.config.primaryColor || '#3b82f6';
      const isLightTheme = theme === 'light';
      const isPrimaryLight = this.isLightColor(primaryColor);

      // If light theme and primary color is light/white → use dark color
      if (isLightTheme && isPrimaryLight) {
        return '#1f2937'; // Dark gray for contrast
      }

      // If dark/black theme and primary color is light/white → use light color
      if (!isLightTheme && isPrimaryLight) {
        return '#ffffff'; // White for contrast
      }

      // Otherwise use primary color
      return primaryColor;
    }


    init() {
      this.createWidget();
      this.loadStyles();
      this.bindEvents();

      // Establish WS connection early if bot credentials are provided
      if (this.config.botUuid && this.config.botSecret) {
        this.ensureWebSocketConnection();
      }

      if (this.config.autoOpen) {
        this.openWidget();
      }
    }

    createWidget() {
      // Create main widget container
      this.widgetElement = document.createElement('div');
      this.widgetElement.id = 'talkida-widget';
      this.widgetElement.className = 'talkida-widget';
      this.widgetElement.style.cssText = `
        position: fixed;
        ${this.getPositionStyles()};
        z-index: ${this.config.zIndex};
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      `;

      // Create chat button
      this.createChatButton();

      // Create chat window
      this.createChatWindow();

      document.body.appendChild(this.widgetElement);
    }

    createChatButton() {
      this.chatButton = document.createElement('button');
      this.chatButton.className = 'talkida-chat-button';
      this.chatButton.style.cssText = `
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: none;
        background-color: ${this.config.primaryColor};
        color: white;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        transition: all 0.3s ease;
      `;

      // Set avatar
      if (this.config.customAvatar) {
        this.chatButton.innerHTML = `<img src="${this.config.customAvatar}" alt="Chat" style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;">`;
      } else {
        this.chatButton.textContent = this.config.chatbotAvatar;
      }

      this.chatButton.addEventListener('click', () => this.toggleWidget());
      this.chatButton.addEventListener('mouseenter', () => {
        this.chatButton.style.transform = 'scale(1.1)';
      });
      this.chatButton.addEventListener('mouseleave', () => {
        this.chatButton.style.transform = 'scale(1)';
      });

      this.widgetElement.appendChild(this.chatButton);
    }

    createChatWindow() {
      this.chatWindow = document.createElement('div');
      this.chatWindow.className = 'talkida-chat-window';

      const savedSize = this.getSavedWindowSize();
      const width = savedSize.width || 320;
      const height = savedSize.height || 400;

      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';
      const glassStyles = isGlass ? this.getGlassStyles() : {};

      this.chatWindow.style.cssText = `
        width: ${width}px;
        height: ${height}px;
        background: ${isGlass ? glassStyles.background : colors.background};
        backdrop-filter: ${isGlass ? glassStyles.backdropFilter : 'none'};
        -webkit-backdrop-filter: ${isGlass ? glassStyles.webkitBackdropFilter : 'none'};
        border: ${isGlass ? glassStyles.border : `1px solid ${colors.border}`};
        border-radius: 12px;
        box-shadow: ${isGlass ? glassStyles.boxShadow : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'};
        display: none;
        flex-direction: column;
        overflow: hidden;
        color: ${colors.text};
        position: relative;
        resize: none;
      `;

      this.createHeader();
      this.createMessagesContainer();
      this.createInputContainer();
      this.createPromoFooter();
      this.createResizeHandle();

      this.widgetElement.appendChild(this.chatWindow);
    }

    createHeader() {
      const header = document.createElement('div');
      header.className = 'talkida-header';
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';

      header.style.cssText = `
    padding: 16px;
    border-bottom: 1px solid ${this.getBorder()};
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${this.getBackground('backgroundSecondary')};
    backdrop-filter: ${this.getBackdropFilter()};
    -webkit-backdrop-filter: ${this.getBackdropFilter()};
  `;

      const botInfo = document.createElement('div');
      botInfo.style.cssText = 'display: flex; align-items: center; gap: 8px;';

      const avatar = document.createElement('div');
      avatar.style.cssText = `
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: ${this.config.primaryColor};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      `;

      if (this.config.customAvatar) {
        avatar.innerHTML = `<img src="${this.config.customAvatar}" alt="Bot" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;">`;
      } else {
        avatar.textContent = this.config.chatbotAvatar;
      }

      const textInfo = document.createElement('div');
      textInfo.innerHTML = `
        <div style="font-weight: 600; font-size: 14px;">${this.config.botName}</div>
        <div style="font-size: 12px; opacity: 0.7;">Online</div>
      `;

      botInfo.appendChild(avatar);
      botInfo.appendChild(textInfo);

      const controls = document.createElement('div');
      controls.style.cssText = 'display: flex; align-items: center; gap: 4px;';

      const minimizeBtn = document.createElement('button');
      minimizeBtn.innerHTML = '−';
      minimizeBtn.style.cssText = `
        width: 24px;
        height: 24px;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 4px;
        color: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      minimizeBtn.addEventListener('click', () => this.toggleMinimize());

      const closeBtn = document.createElement('button');
      closeBtn.innerHTML = '×';
      closeBtn.style.cssText = `
        width: 24px;
        height: 24px;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 4px;
        color: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      `;
      closeBtn.addEventListener('click', () => this.closeWidget());

      controls.appendChild(minimizeBtn);
      controls.appendChild(closeBtn);

      header.appendChild(botInfo);
      header.appendChild(controls);

      this.chatWindow.appendChild(header);
    }

    createMessagesContainer() {
      this.messagesContainer = document.createElement('div');
      this.messagesContainer.className = 'talkida-messages';
      this.messagesContainer.style.cssText = `
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      `;

      // UPDATED: Use greetingMsg instead of welcomeMessage
      if (this.config.showWelcomeMessage) {
        this.addMessage(this.config.greetingMsg, 'bot');
      }

      this.chatWindow.appendChild(this.messagesContainer);
    }

    createInputContainer() {
      const inputContainer = document.createElement('div');
      inputContainer.className = 'talkida-input-container';
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';

      inputContainer.style.cssText = `
        padding: 16px;
        border-top: 1px solid ${isGlass ? 'rgba(255, 255, 255, 0.1)' : colors.border};
        display: flex;
        gap: 8px;
      `;

      this.inputField = document.createElement('input');
      this.inputField.type = 'text';
      this.inputField.placeholder = this.config.placeholder;
      this.inputField.style.cssText = `
        flex: 1;
        padding: 8px 12px;
        border: 1px solid ${colors.inputBorder};
        border-radius: 6px;
        background: ${isGlass ? 'rgba(255, 255, 255, 0.1)' : colors.inputBackground};
        backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
        -webkit-backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
        color: ${colors.text};
        outline: none;
        font-size: 14px;
      `;

      const sendBtn = document.createElement('button');
      sendBtn.innerHTML = '→';
      sendBtn.style.cssText = `
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 6px;
        background-color: ${this.config.primaryColor};
        color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      `;

      sendBtn.addEventListener('click', () => this.sendMessage());
      this.inputField.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') this.sendMessage();
      });

      inputContainer.appendChild(this.inputField);
      inputContainer.appendChild(sendBtn);

      this.chatWindow.appendChild(inputContainer);
    }

    createPromoFooter() {
      const promo = document.createElement('div');
      promo.className = 'talkida-footer';
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';
      promo.style.cssText = `
        padding: 6px 8px;
        text-align: center;
        font-size: 11px;
        line-height: 1.2;
        color: ${colors.textSecondary};
        background: ${isGlass ? 'rgba(0, 0, 0, 0.1)' : colors.background};
        backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
        -webkit-backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
      `;
      const linkColor = this.getContrastingLinkColor();
      promo.innerHTML = `Powered by <a href="http://talkida.co.in/" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: ${linkColor}; font-weight: 600;">Talkida AI</a>`;
      if (this.config.isPremiumMember) {
        promo.style.display = 'none';
      }
      this.chatWindow.appendChild(promo);
    }

    createResizeHandle() {
      const resizeHandle = document.createElement('div');
      resizeHandle.className = 'talkida-resize-handle';
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';
      const primary = this.config.primaryColor || '#3b82f6';
      const theme = this.config.theme || 'dark';
      const isLight = theme === 'light';

      resizeHandle.style.cssText = `
        position: absolute;
        top: 8px;
        right: 8px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        cursor: nesw-resize;
        z-index: 1000;
        background: ${isGlass ? 'rgba(255,255,255,0.15)' : (isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.08)')};
        backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
        -webkit-backdrop-filter: ${isGlass ? 'blur(10px)' : 'none'};
        border: 1px solid ${isGlass ? 'rgba(255,255,255,0.2)' : (isLight ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.3)')};
        box-shadow: 0 1px 3px rgba(0,0,0,0.15);
        transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;
      `;

      resizeHandle.addEventListener('mouseenter', () => {
        resizeHandle.style.transform = 'scale(1.1)';
        resizeHandle.style.background = isGlass ? 'rgba(255,255,255,0.25)' : (isLight ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.14)');
        resizeHandle.style.borderColor = primary;
      });
      resizeHandle.addEventListener('mouseleave', () => {
        resizeHandle.style.transform = 'scale(1)';
        resizeHandle.style.background = isGlass ? 'rgba(255,255,255,0.15)' : (isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.08)');
        resizeHandle.style.borderColor = isGlass ? 'rgba(255,255,255,0.2)' : (isLight ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.3)');
      });

      // Resize functionality
      let isResizing = false;
      let startX, startY, startWidth, startHeight;

      resizeHandle.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        isResizing = true;
        startX = e.clientX;
        startY = e.clientY;
        const rect = this.chatWindow.getBoundingClientRect();
        startWidth = rect.width;
        startHeight = rect.height;

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        // Prevent text selection during resize
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'nesw-resize';
      });

      const handleMouseMove = (e) => {
        if (!isResizing) return;

        const deltaX = e.clientX - startX;
        const deltaY = e.clientY - startY;

        // Min and max constraints
        const minWidth = 280;
        const maxWidth = 600;
        const minHeight = 300;
        const maxHeight = 800;

        // Calculate new dimensions
        // For top-right corner: right increases width, UP should INCREASE height per requested UX
        let newWidth = startWidth + deltaX;
        let newHeight = startHeight - deltaY; // invert Y so dragging up grows

        // Apply constraints
        newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
        newHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));

        // Apply the new dimensions
        this.chatWindow.style.width = `${newWidth}px`;
        this.chatWindow.style.height = `${newHeight}px`;
      };

      const handleMouseUp = () => {
        if (isResizing) {
          isResizing = false;
          const currentWidth = parseInt(window.getComputedStyle(this.chatWindow).width, 10);
          const currentHeight = parseInt(window.getComputedStyle(this.chatWindow).height, 10);
          this.saveWindowSize(currentWidth, currentHeight);
        }

        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
      };

      this.chatWindow.appendChild(resizeHandle);
    }

    addMessage(content, sender) {
      const messageDiv = document.createElement('div');
      messageDiv.className = `talkida-message talkida-message-${sender}`;

      const isUser = sender === 'user';
      const colors = this.getThemeColors();
      const isGlass = this.config.themeStyle === 'glass';

      messageDiv.style.cssText = `
        max-width: 80%;
        padding: 8px 12px;
        border-radius: 12px;
        font-size: 14px;
        line-height: 1.4;
        word-wrap: break-word;
        align-self: ${isUser ? 'flex-end' : 'flex-start'};
        background: ${isUser ? this.config.primaryColor : this.getBackground('messageBackground')};
        backdrop-filter: ${isUser ? 'none' : this.getBackdropFilter()};
        -webkit-backdrop-filter: ${isUser ? 'none' : this.getBackdropFilter()};
        color: ${isUser ? 'white' : colors.text};
        ${isGlass && !isUser ? `border: 1px solid ${colors.glassBorder};` : ''}
      `;

      // Format message: bold asterisks and auto-link URLs (only for bot messages)
      if (sender === 'bot') {
        messageDiv.innerHTML = this.formatMessage(content, this.config.primaryColor);
        // Style links within the message
        const links = messageDiv.querySelectorAll('a');
        links.forEach(link => {
          link.style.color = isUser ? '#ffffff' : (this.config.primaryColor || '#3b82f6');
          link.style.textDecoration = 'underline';
          link.style.cursor = 'pointer';
          // Add hover effect
          link.addEventListener('mouseenter', () => {
            link.style.opacity = '0.8';
          });
          link.addEventListener('mouseleave', () => {
            link.style.opacity = '1';
          });
        });
      } else {
        messageDiv.textContent = content;
      }
      this.messagesContainer.appendChild(messageDiv);
      this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
    }

    async sendMessage() {
      const message = this.inputField.value.trim();
      if (!message) return;

      this.addMessage(message, 'user');
      this.inputField.value = '';

      // Show typing indicator
      const typingDiv = document.createElement('div');
      typingDiv.className = 'talkida-typing';
      typingDiv.innerHTML = `
        <div style="display: flex; gap: 4px; padding: 8px 12px;">
          <div style="width: 6px; height: 6px; background: #9ca3af; border-radius: 50%; animation: talkida-typing 1.4s infinite;"></div>
          <div style="width: 6px; height: 6px; background: #9ca3af; border-radius: 50%; animation: talkida-typing 1.4s infinite 0.2s;"></div>
          <div style="width: 6px; height: 6px; background: #9ca3af; border-radius: 50%; animation: talkida-typing 1.4s infinite 0.4s;"></div>
        </div>
      `;
      this.messagesContainer.appendChild(typingDiv);
      this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;

      try {
        if (this.config.botUuid && this.config.botSecret) {
          await this.ensureWebSocketConnection();
          // Queue send if not ready yet; otherwise send immediately
          const sendFn = () => {
            try {
              this.websocket.send(JSON.stringify({ query: message }));
            } catch (e) {
              // Fall back to HTTP if WS send fails
              this.callAPI(message)
                .then((response) => {
                  typingDiv.remove();
                  this.addMessage(response, 'bot');
                })
                .catch(() => {
                  typingDiv.remove();
                  this.addMessage(this.config.notFoundInfo, 'bot');
                });
              return;
            }
          };

          if (this.isWsReady) {
            sendFn();
          } else {
            this.pendingMessages.push({ message, typingDiv });
          }
        } else {
          const response = await this.callAPI(message);
          typingDiv.remove();
          this.addMessage(response, 'bot');
        }
      } catch (error) {
        typingDiv.remove();
        this.addMessage(this.config.notFoundInfo, 'bot');
      }
    }

    async callAPI(message) {
      const response = await fetch('/api/chat/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.config.apiKey}`
        },
        body: JSON.stringify({
          message,
          chatbotId: this.config.chatbotId,
          conversationId: this.getConversationId(),
          // UPDATED: Include all new config options
          config: {
            llmProvider: this.config.llmProvider,
            modelName: this.config.modelName,
            maxTokens: this.config.maxTokens,
            temperature: this.config.temperature,
            customSystPrompt: this.config.customSystPrompt,
            botAim: this.config.botAim,
            companyName: this.config.companyName,
            botName: this.config.botName,
            greetingMsg: this.config.greetingMsg,
            byeMsg: this.config.byeMsg,
            notFoundInfo: this.config.notFoundInfo
          }
        })
      });

      if (!response.ok) {
        throw new Error('API call failed');
      }

      const data = await response.json();
      return data.response || data.message || this.config.notFoundInfo;
    }

    async ensureWebSocketConnection() {
      if (this.isWsReady || this.isConnecting) return;
      this.isConnecting = true;

      try {
        // Exchange provided bot credentials for a websocket access token
        const wsTokenRes = await fetch(`${this.config.apiBaseUrl}/api/ws_token`, {
          method: 'POST',
          headers: {
            'X-Bot-UUID': this.config.botUuid,
            'X-Bot-Secret': this.config.botSecret
          }
        });
        if (!wsTokenRes.ok) throw new Error('Failed to get websocket token');
        const wsTokens = await wsTokenRes.json();
        const wsAccessToken = wsTokens.ws_access_token;

        // Connect websocket (attach existing_lead if available)
        const host = new URL(this.config.apiBaseUrl).host;
        const params = new URLSearchParams({ token: wsAccessToken });
        try {
          const existingLead = this.getStoredLeadUuid ? this.getStoredLeadUuid() : '';
          if (existingLead) params.set('existing_lead', existingLead);
        } catch (_) { }
        const wsUrl = `wss://${host}${this.config.wsPath}?${params.toString()}`;
        try { console.log('[TalkidaWidget] Connecting WS →', wsUrl); } catch (_) { }
        this.websocket = new WebSocket(wsUrl);

        this.websocket.onopen = () => {
          this.isWsReady = true;
          this.isConnecting = false;
          try { console.log('[TalkidaWidget] WS connected'); } catch (_) { }
          // Flush any queued messages
          const queued = [...this.pendingMessages];
          this.pendingMessages = [];
          queued.forEach(({ message, typingDiv }) => {
            try {
              this.websocket.send(JSON.stringify({ query: message }));
              try { console.log('[TalkidaWidget] →', { query: message }); } catch (_) { }
            } catch (e) {
              if (typingDiv) typingDiv.remove();
              this.addMessage(this.config.notFoundInfo, 'bot');
            }
          });
        };

        this.websocket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            // commented out for now to avoid console spam
            // try { console.log('[TalkidaWidget] ←', data); } catch (_) { }
            // Persist lead UUID if provided by server
            if (data && data.lead_uuid && this.setStoredLeadUuid) {
              try { this.setStoredLeadUuid(data.lead_uuid); } catch (_) { }
            }
            const text = data.response || data.message || this.config.notFoundInfo;
            // Remove an existing typing indicator if present
            const typing = this.messagesContainer.querySelector('.talkida-typing');
            if (typing) typing.remove();
            this.addMessage(text, 'bot');
          } catch (e) {
            const typing = this.messagesContainer.querySelector('.talkida-typing');
            if (typing) typing.remove();
            this.addMessage(this.config.notFoundInfo, 'bot');
          }
        };

        this.websocket.onerror = () => {
          this.isWsReady = false;
          try { console.log('[TalkidaWidget] WS error'); } catch (_) { }
        };

        this.websocket.onclose = () => {
          this.isWsReady = false;
          try { console.log('[TalkidaWidget] WS closed'); } catch (_) { }
        };
      } catch (e) {
        this.isConnecting = false;
        this.isWsReady = false;
        // Fail silently; HTTP fallback in send flow will handle messaging
      }
    }

    getConversationId() {
      if (!this.conversationId) {
        this.conversationId = `conv_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      }
      return this.conversationId;
    }

    toggleWidget() {
      this.isOpen = !this.isOpen;
      this.chatButton.style.display = this.isOpen ? 'none' : 'flex';
      this.chatWindow.style.display = this.isOpen ? 'flex' : 'none';

      if (this.isOpen) {
        this.inputField.focus();
      }
    }

    closeWidget() {
      this.isOpen = false;
      this.isMinimized = false;
      this.chatButton.style.display = 'flex';
      this.chatWindow.style.display = 'none';
    }

    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
      if (this.isMinimized) {
        this.chatWindow.style.height = '60px';
        this.messagesContainer.style.display = 'none';
        this.chatWindow.querySelector('.talkida-input-container').style.display = 'none';
        const resizeHandle = this.chatWindow.querySelector('.talkida-resize-handle');
        if (resizeHandle) resizeHandle.style.display = 'none';
      } else {
        const savedSize = this.getSavedWindowSize();
        const restoredHeight = savedSize.height || 400;
        this.chatWindow.style.height = `${restoredHeight}px`;
        this.messagesContainer.style.display = 'flex';
        this.chatWindow.querySelector('.talkida-input-container').style.display = 'flex';
        const resizeHandle = this.chatWindow.querySelector('.talkida-resize-handle');
        if (resizeHandle) resizeHandle.style.display = 'block';
      }
    }

    getPositionStyles() {
      const positions = {
        'bottom-right': 'bottom: 20px; right: 20px;',
        'bottom-left': 'bottom: 20px; left: 20px;',
        'top-right': 'top: 20px; right: 20px;',
        'top-left': 'top: 20px; left: 20px;'
      };
      return positions[this.config.position] || positions['bottom-right'];
    }

    loadStyles() {
      if (document.getElementById('talkida-styles')) return;

      const style = document.createElement('style');
      style.id = 'talkida-styles';
      style.textContent = `
        @keyframes talkida-typing {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-10px); }
        }
        
        .talkida-widget * {
          box-sizing: border-box;
        }
        
        .talkida-chat-button:hover {
          transform: scale(1.05) !important;
        }
        
        .talkida-messages::-webkit-scrollbar {
          width: 4px;
        }
        
        .talkida-messages::-webkit-scrollbar-track {
          background: transparent;
        }
        
        .talkida-messages::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 2px;
        }
        
        .talkida-messages::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
      `;
      document.head.appendChild(style);
    }

    bindEvents() {
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeWidget();
        }
      });
    }

    // Public API methods
    open() {
      if (!this.isOpen) this.toggleWidget();
    }

    close() {
      if (this.isOpen) this.closeWidget();
    }

    updateConfig(newConfig) {
      this.config = { ...this.config, ...newConfig };
      this.applyConfigToUI();
    }

    async fetchAndApplyApiConfig() {
      if (!(this.config.botUuid && this.config.botSecret)) return false;

      try {
        const res = await fetch('https://api.talkida.co.in/api/model/cdn-bot-details', {
          method: 'GET',
          headers: {
            'X-Bot-UUID': this.config.botUuid,
            'X-Bot-Secret': this.config.botSecret
          }
        });

        if (!res.ok) return false;
        const data = await res.json();

        const apiConfig = {
          botName: data.bot_name,
          companyName: data.company_name,
          position: data.position,
          theme: data.theme,
          themeStyle: data.theme_style || this.config.themeStyle, // Preserve existing if API doesn't provide it
          primaryColor: data.primary_color,
          placeholder: data.placeholder_text,
          showWelcomeMessage: data.show_welcome_message,
          autoOpen: data.auto_open,
          zIndex: data.z_index,
          isPremiumMember: data.is_premium_member === true
        };

        // Override with API to reflect latest server-side settings
        const merged = { ...this.config, ...apiConfig };

        if (data.chatbot_avatar_img) {
          merged.customAvatar = data.chatbot_avatar_img;
        } else if (data.chatbot_avatar_emoji) {
          merged.chatbotAvatar = data.chatbot_avatar_emoji;
          if (merged.customAvatar) merged.customAvatar = '';
        }

        const wasOpen = this.isOpen;
        this.updateConfig(merged);
        if (wasOpen) this.open();
        return true;
      } catch (_) {
        return false;
      }
    }

    destroy() {
      if (this.widgetElement && this.widgetElement.parentNode) {
        this.widgetElement.parentNode.removeChild(this.widgetElement);
      }
    }
  }

  // Non-destructive UI application of current config
  TalkidaWidget.prototype.applyConfigToUI = function () {
    if (!this.widgetElement || !this.chatButton || !this.chatWindow) return;

    // Position and z-index
    this.widgetElement.style.zIndex = this.config.zIndex;
    // Reset all sides then set the chosen
    this.widgetElement.style.top = 'auto';
    this.widgetElement.style.right = 'auto';
    this.widgetElement.style.bottom = 'auto';
    this.widgetElement.style.left = 'auto';
    const pos = this.config.position || 'bottom-right';
    if (pos.includes('bottom')) this.widgetElement.style.bottom = '20px';
    if (pos.includes('top')) this.widgetElement.style.top = '20px';
    if (pos.includes('right')) this.widgetElement.style.right = '20px';
    if (pos.includes('left')) this.widgetElement.style.left = '20px';

    // Button color and avatar
    this.chatButton.style.backgroundColor = this.config.primaryColor;
    if (this.config.customAvatar) {
      this.chatButton.innerHTML = `<img src="${this.config.customAvatar}" alt="Chat" style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;">`;
    } else {
      this.chatButton.innerHTML = '';
      this.chatButton.textContent = this.config.chatbotAvatar;
    }

    // Theme colors
    const colors = this.getThemeColors();
    const isGlass = this.config.themeStyle === 'glass';
    const glassStyles = isGlass ? this.getGlassStyles() : {};

    this.chatWindow.style.background = isGlass ? glassStyles.background : colors.background;
    this.chatWindow.style.backdropFilter = isGlass ? glassStyles.backdropFilter : 'none';
    this.chatWindow.style.webkitBackdropFilter = isGlass ? glassStyles.backdropFilter : 'none';
    this.chatWindow.style.border = isGlass ? glassStyles.border : `1px solid ${colors.border}`;
    this.chatWindow.style.boxShadow = isGlass ? glassStyles.boxShadow : '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
    this.chatWindow.style.color = colors.text;

    const header = this.chatWindow.querySelector('.talkida-header');
    if (header) {
      header.style.background = isGlass ? 'rgba(0, 0, 0, 0.1)' : colors.backgroundSecondary;
      header.style.backdropFilter = isGlass ? 'blur(10px)' : 'none';
      header.style.webkitBackdropFilter = isGlass ? 'blur(10px)' : 'none';
      header.style.borderBottom = `1px solid ${isGlass ? 'rgba(255, 255, 255, 0.1)' : colors.border}`;

      // Update avatar circle and bot name
      const botInfo = header.children && header.children[0];
      if (botInfo) {
        const avatarDiv = botInfo.children && botInfo.children[0];
        const textInfo = botInfo.children && botInfo.children[1];
        if (avatarDiv) {
          avatarDiv.style.backgroundColor = this.config.primaryColor;
          if (this.config.customAvatar) {
            avatarDiv.innerHTML = `<img src="${this.config.customAvatar}" alt="Bot" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;">`;
          } else {
            avatarDiv.innerHTML = '';
            avatarDiv.textContent = this.config.chatbotAvatar;
          }
        }
        if (textInfo && textInfo.children && textInfo.children[0]) {
          textInfo.children[0].textContent = this.config.botName;
        }
      }
    }

    // Input container styles
    const inputContainer = this.chatWindow.querySelector('.talkida-input-container');
    if (inputContainer) {
      inputContainer.style.borderTop = `1px solid ${isGlass ? 'rgba(255, 255, 255, 0.1)' : colors.border}`;
      // Input field
      if (this.inputField) {
        this.inputField.placeholder = this.config.placeholder;
        this.inputField.style.border = `1px solid ${colors.inputBorder}`;
        this.inputField.style.background = isGlass ? 'rgba(255, 255, 255, 0.1)' : colors.inputBackground;
        this.inputField.style.backdropFilter = isGlass ? 'blur(10px)' : 'none';
        this.inputField.style.webkitBackdropFilter = isGlass ? 'blur(10px)' : 'none';
        this.inputField.style.color = colors.text;
      }
      // Send button (first button in container)
      const sendBtn = inputContainer.querySelector('button');
      if (sendBtn) {
        sendBtn.style.backgroundColor = this.config.primaryColor;
        sendBtn.style.color = '#ffffff';
      }
    }

    // Promo footer styles
    const promo = this.chatWindow.querySelector('.talkida-footer');
    if (promo) {
      promo.style.color = colors.textSecondary;
      promo.style.background = isGlass ? 'rgba(0, 0, 0, 0.1)' : colors.background;
      promo.style.backdropFilter = isGlass ? 'blur(10px)' : 'none';
      promo.style.webkitBackdropFilter = isGlass ? 'blur(10px)' : 'none';
      promo.style.display = this.config.isPremiumMember ? 'none' : 'block';
      const link = promo.querySelector('a');
      if (link) {
        link.style.color = this.getContrastingLinkColor();
      }
    }

    // Update resize handle theme
    const resizeHandle = this.chatWindow.querySelector('.talkida-resize-handle');
    if (resizeHandle) {
      const theme = this.config.theme || 'dark';
      const isLight = theme === 'light';
      resizeHandle.style.background = isGlass ? 'rgba(255,255,255,0.15)' : (isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.08)');
      resizeHandle.style.backdropFilter = isGlass ? 'blur(10px)' : 'none';
      resizeHandle.style.webkitBackdropFilter = isGlass ? 'blur(10px)' : 'none';
      resizeHandle.style.borderColor = isGlass ? 'rgba(255,255,255,0.2)' : (isLight ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.3)');
    }
  };

  // Lead persistence helpers
  TalkidaWidget.prototype.getLeadStorageKey = function () {
    const id = this.config && this.config.botUuid ? this.config.botUuid : 'default';
    return `talkida_lead_uuid_${id}`;
  };

  TalkidaWidget.prototype.getStoredLeadUuid = function () {
    try {
      return localStorage.getItem(this.getLeadStorageKey()) || '';
    } catch (_) {
      return '';
    }
  };

  TalkidaWidget.prototype.setStoredLeadUuid = function (uuid) {
    try {
      if (uuid && typeof uuid === 'string' && uuid.length > 0) {
        localStorage.setItem(this.getLeadStorageKey(), uuid);
      }
    } catch (_) { }
  };

  // Window size persistence helpers
  TalkidaWidget.prototype.getWindowSizeStorageKey = function () {
    const id = this.config && this.config.botUuid ? this.config.botUuid : 'default';
    return `talkida_window_size_${id}`;
  };

  TalkidaWidget.prototype.getSavedWindowSize = function () {
    try {
      const saved = localStorage.getItem(this.getWindowSizeStorageKey());
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed.width === 'number' && typeof parsed.height === 'number') {
          return { width: parsed.width, height: parsed.height };
        }
      }
    } catch (_) { }
    return { width: null, height: null };
  };

  TalkidaWidget.prototype.saveWindowSize = function (width, height) {
    try {
      if (width && height && typeof width === 'number' && typeof height === 'number') {
        localStorage.setItem(this.getWindowSizeStorageKey(), JSON.stringify({ width, height }));
      }
    } catch (_) { }
  };

  // Global initialization
  window.TalkidaWidget = TalkidaWidget;

  // UPDATED: Auto-initialize with all new data attributes
  document.addEventListener('DOMContentLoaded', () => {
    const script = document.querySelector('script[src*="talkida-widget.js"]');
    if (script) {
      const config = {};

      // UPDATED: Extract all new config from data attributes
      const dataAttrs = [
        'api-key', 'chatbot-id', 'position', 'theme', 'theme-style', 'primary-color',
        'welcome-message', 'show-welcome-message', 'show-welcome', 'placeholder', 'auto-open', 'z-index',
        'bot-name', 'chatbot-avatar', 'custom-avatar', 'bye-message',
        'not-found-info', 'llm-provider', 'model-name', 'max-tokens',
        'temperature', 'bot-aim', 'company-name',
        // New direct bot credentials
        'bot-id', 'bot-token'
      ];

      dataAttrs.forEach(attr => {
        const value = script.getAttribute(`data-${attr}`);
        if (value !== null) {
          const key = attr.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
          config[key] = value === 'true' ? true : value === 'false' ? false : value;
        }
      });

      // Debug: Log themeStyle if set (can be removed in production)
      if (config.themeStyle) {
        try { console.log('[TalkidaWidget] Theme style from data attribute:', config.themeStyle); } catch (_) { }
      }

      // Map legacy welcome-message to internal greetingMsg (used in UI)
      if (config.welcomeMessage && !config.greetingMsg) {
        config.greetingMsg = config.welcomeMessage;
      }

      // Alias: data-show-welcome → showWelcomeMessage
      if (config.showWelcome !== undefined && config.showWelcomeMessage === undefined) {
        config.showWelcomeMessage = config.showWelcome;
      }

      // Explicitly allow non-data attributes for bot credentials
      const nonDataBotId = script.getAttribute('bot-id');
      const nonDataBotToken = script.getAttribute('bot-token');
      if (nonDataBotId && !config.botId) config.botId = nonDataBotId;
      if (nonDataBotToken && !config.botToken) config.botToken = nonDataBotToken;

      // Normalize to internal keys
      if (config.botId && !config.botUuid) config.botUuid = config.botId;
      if (config.botToken && !config.botSecret) config.botSecret = config.botToken;

      // Instantiate immediately with provided params
      const instantiateNow = () => {
        const initialConfig = { ...config };
        if ((initialConfig.botUuid && initialConfig.botSecret) || (initialConfig.apiKey && initialConfig.chatbotId)) {
          window.talkidaInstance = new TalkidaWidget(initialConfig);
        }
      };

      // Fire immediate instantiation for initial UI
      instantiateNow();

      // In parallel, fetch CDN bot details and update UI when received
      const fetchAndUpdateFromApi = async () => {
        const base = { ...config };
        if (!(base.botUuid && base.botSecret)) return;
        try {
          const res = await fetch('https://api.talkida.co.in/api/model/cdn-bot-details', {
            method: 'GET',
            headers: {
              'X-Bot-UUID': base.botUuid,
              'X-Bot-Secret': base.botSecret
            }
          });
          if (!res.ok) return;
          const data = await res.json();

          const apiConfig = {
            botName: data.bot_name,
            companyName: data.company_name,
            position: data.position,
            theme: data.theme,
            themeStyle: data.theme_style || base.themeStyle, // Preserve data attribute if API doesn't provide it
            primaryColor: data.primary_color,
            placeholder: data.placeholder_text,
            showWelcomeMessage: data.show_welcome_message,
            autoOpen: data.auto_open,
            zIndex: data.z_index,
            isPremiumMember: data.is_premium_member === true
          };

          // Override with API to reflect latest server-side settings
          const merged = { ...base, ...apiConfig };

          if (data.chatbot_avatar_img) {
            merged.customAvatar = data.chatbot_avatar_img;
          } else if (data.chatbot_avatar_emoji) {
            merged.chatbotAvatar = data.chatbot_avatar_emoji;
            if (merged.customAvatar) merged.customAvatar = '';
          }

          if (window.talkidaInstance) {
            const wasOpen = window.talkidaInstance.isOpen;
            window.talkidaInstance.updateConfig(merged);
            if (wasOpen) window.talkidaInstance.open();
          } else if ((merged.botUuid && merged.botSecret) || (merged.apiKey && merged.chatbotId)) {
            window.talkidaInstance = new TalkidaWidget(merged);
          }
        } catch (_) {
          // silent
        }
      };

      fetchAndUpdateFromApi();
    }
  });

})();
